import { CreateTaskPayload, CrmTask, GetTasksParams } from "types/crm/task";
import { CrmTaskListItem } from "types/crm/task";
import { usePaginatedList } from "../usePaginatedList";
import { useEntityCreateMutation } from "../useEntityMutation";
import { taskApi, taskQueryKeys } from "service/crm/api/task";

export const useTasks = (params: GetTasksParams = {}, pageSize = 20) => {
  const { items, ...rest } = usePaginatedList<CrmTaskListItem>(
    taskQueryKeys.list(params),
    (page) => taskApi.getAllTasks({ ...params, page, size: pageSize }),
    true,
  );
  return { tasks: items, ...rest };
};

export const useCreateCrmTaskMutation = () =>
  useEntityCreateMutation<CreateTaskPayload, CrmTask>(
    (payload) => taskApi.createTask(payload),
    () => [taskQueryKeys.all],
  );